import React, { useState } from 'react'
import { Dropdown, Button, Input, message, Popconfirm } from 'antd'
import type { MenuProps } from 'antd'
import { UserOutlined, DownOutlined, KeyOutlined, ReloadOutlined, LogoutOutlined } from '@ant-design/icons'
import { useToken } from 'app/hooks'
import { useHistory } from 'react-router-dom'
import { ProfileButton } from './styles'
import API from 'utils/api'

const ProfileDropdown: React.FC = () => {
  const { data: token, level, mutate } = useToken()
  const navigation = useHistory()
  const [password, setPassword] = useState('')

  const handleLogout = () => {
    mutate(null)
    navigation.push('/login')
  }

  const handlePasswordChange = () => {
    if (password.length < 4) {
      message.error('4자리 이상만 가능합니다.')
      return
    }

    API.put('/user/my/password', token + '', {
      password: password,
    }).then(res => {
      message.success('변경 성공')
      setPassword('')
    }).catch(err => {
      message.error('변경 실패')
    })
  }

  const handleAdminReset = () => {
    API.post('/admin/dev/resetadmin', token + '', {
    }).then(res => {
      message.success('리셋성공')
    }).catch(err => {
      message.error('리셋 실패')
    })
  }

  const menuItems: MenuProps['items'] = [
    {
      key: 'password',
      label: (
        <Popconfirm
          title={
            <div style={{ padding: '8px 0' }}>
              <div style={{ marginBottom: '8px', color: '#666' }}>새 비밀번호를 입력하세요</div>
              <Input
                size="small"
                type="password"
                placeholder="4자리 이상"
                value={password}
                onChange={e => setPassword(e.target.value)}
                style={{ width: '200px' }}
              />
            </div>
          }
          onConfirm={handlePasswordChange}
          onCancel={() => setPassword('')}
          okText="변경"
          cancelText="취소"
        >
          <div style={{ padding: '8px 0', display: 'flex', alignItems: 'center', gap: '8px' }}>
            <KeyOutlined />
            암호변경
          </div>
        </Popconfirm>
      ),
    },
    ...(level == 99 ? [{
      key: 'admin-reset',
      label: (
        <Popconfirm
          title="관리자 API서버리셋은 꼭 필요할때만 해주세요. 1번만 눌러주세요"
          onConfirm={handleAdminReset}
          okText="리셋"
          cancelText="취소"
          okButtonProps={{ danger: true }}
        >
          <div style={{ padding: '8px 0', display: 'flex', alignItems: 'center', gap: '8px', color: '#ff4d4f' }}>
            <ReloadOutlined />
            관리자리셋
          </div>
        </Popconfirm>
      ),
    }] : []),
    {
      type: 'divider',
    },
    {
      key: 'logout',
      label: (
        <div
          style={{ padding: '8px 0', display: 'flex', alignItems: 'center', gap: '8px', color: '#ff4d4f' }}
          onClick={handleLogout}
        >
          <LogoutOutlined />
          로그아웃
        </div>
      ),
    },
  ]

  if (!token) {
    return (
      <Button
        type="primary"
        size="small"
        onClick={() => navigation.push('/login')}
      >
        로그인
      </Button>
    )
  }

  return (
    <Dropdown
      menu={{ items: menuItems }}
      trigger={['click']}
      placement="bottomRight"
    >
      <ProfileButton>
        <UserOutlined className="profile-icon" />
        <span className="profile-text">Admin</span>
        <DownOutlined className="dropdown-arrow" />
      </ProfileButton>
    </Dropdown>
  )
}

export default React.memo(ProfileDropdown)